module.exports = __webpack_public_path__ + "img/_icon_download.339716a3.svg";